import api from "./core";
const config = require("./serverCfg").default;

const basePath = "api/core/Documents";

export default {
  query(filter, extraHeaders = {}) {
    return api.post(`${basePath}/Search`, filter, extraHeaders);
  },
  queryImproved(filter, extraHeaders = {}) {
    return api.post(`${basePath}/SearchImproved`, filter, extraHeaders);
  },
  findByDateRange(id, filter) {
    return api.post(`${basePath}/ByEocAndDateRange/${id}`, filter);
  },
  findAllDeleted(filter) {
    return api.post(`${basePath}/FindAllDeleted`, filter);
  },
  restore(id, extraHeaders = {}) {
    return api.post(`${basePath}/Restore/${id}`, {}, extraHeaders);
  },
  delete(id) {
    return api.delete(`${basePath}/${id}`);
  },
  documentViewUrl(documentId) {
    return {
      url: `${config.coreBaseUrl}${basePath}/RenderDocument/${documentId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${config.token}`
      }
    };
  },
  treatmentPlanDocumentViewUrl(treatmentPlanDocumentId) {
    return {
      url: `${config.coreBaseUrl}${basePath}/RenderTreatmentPlan/${treatmentPlanDocumentId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${config.token}`
      }
    };
  },
  documentsViewUrl(documentIds) {
    return {
      url: `${config.coreBaseUrl}${basePath}/RenderDocuments/${documentIds.join(
        ","
      )}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${config.token}`
      }
    };
  },
  eocDocumentsViewUrl(eocId) {
    return {
      url: `${config.coreBaseUrl}${basePath}/RenderEpisodeOfCareDocuments/${eocId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${config.token}`
      }
    };
  },
  updateNotes(id, data, extraHeaders = {}) {
    return api.patch(`${basePath}/Notes/${id}`, data, extraHeaders);
  },
  documentsFromIds(ids) {
    return api.post(`${basePath}/DocumentsFromIds`, ids);
  },
  documentsFromIdsImproved(ids) {
    return api.post(`${basePath}/DocumentsFromIdsImproved`, ids);
  },
  downloadDocumentPdf(ids) {
    return fetch(`${config.coreBaseUrl}${basePath}/DownloadDocumentsPdf`, {
      method: "POST",
      body: JSON.stringify(ids),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${config.token}`
      }
    });
  },
  sendDocumentsPdf(data) {
    return fetch(`${config.coreBaseUrl}${basePath}/SendDocumentsPdf`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${config.token}`
      }
    });
  },
  sendTreatmentPlanPdf(data) {
    return fetch(`${config.coreBaseUrl}${basePath}/SendTreatmentPlanPdf`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${config.token}`
      }
    });
  },
  downloadtreatmentPlanPdf(ids) {
    return fetch(`${config.coreBaseUrl}${basePath}/DownloadTreatmentPlanPdf`, {
      method: "POST",
      body: JSON.stringify(ids),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${config.token}`
      }
    });
  },
  downloadEocPdf(ids) {
    return fetch(`${config.coreBaseUrl}${basePath}/DownloadEpisodeOfCarePdf`, {
      method: "POST",
      body: JSON.stringify(ids),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${config.token}`
      }
    });
  },
  sendEocPdf(ids) {
    return fetch(`${config.coreBaseUrl}${basePath}/SendEpisodeOfCarePdf`, {
      method: "POST",
      body: JSON.stringify(ids),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${config.token}`
      }
    });
  },
  getOmtResults(eocId) {
    return api.get(`${basePath}/OmtResults/${eocId}`);
  },
  getLastDocument(formId, versionId, eocId, currentDocumentId = null) {
    return api.post(`${basePath}/GetLastDocument`, {
      formId,
      versionId,
      episodeOfCareId: eocId,
      currentDocumentId
    });
  },
  queryByEoc(category, eocId) {
    return api.post(`${basePath}/ByEocAndCategory/${category}/${eocId}`);
  },
  getDocumentsContent(documentIds) {
    return api.get(`${basePath}/DocumentsContent/${documentIds.join(",")}`);
  },
  renderDocuments() {
    return {
      url: `${config.coreBaseUrl}${basePath}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${config.token}`
      }
    };
  }
};
